export default {
  baseUrl: process.env.REACT_APP_SERVER_URL || window.location.origin,
  timeout: 1000000, // 10000,
  xsrf: '94ff6c98-3a04-416f-aa58-9046271ea5d7',
  routes: {
    register: 'evisauaa/api/register',
    login: 'auth/login',
    logout: 'auth/logout',
    getSession: 'evisauaa/api/account',
    activate: 'evisauaa/api/activate?key=',
    changePassword: 'evisauaa/api/account/change-password',
    passwordChangeInit: 'evisauaa/api/account/reset-password/init',
    passwordChangeFinish: 'evisauaa/api/account/reset-password/finish',
    getConfiguration: 'evisaonline/api/visa-configurations',
    getUsers: 'evisaservice/api/user-assignments/local-officers',
    getVisaFees: visaTypeId =>
      `evisaonline/api/visa-fees?visatypeId.equals=${visaTypeId}`,
    getVisaApplications: 'evisaonline/api/visa-applications',
    getApplication: uuid => `evisaonline/api/visa-applications/${uuid}`,
    createApplication: 'evisaonline/api/visa-applications',
    updateApplication: uuid => `evisaonline/api/visa-applications/${uuid}`,
    completeApplication: uuid =>
      `evisaonline/api/visa-applications/${uuid}/complete`,
    getQuote: 'evisapayment/api/quote',
    getExistedQuote: uuid => `evisapayment/api/quote/visa-application/${uuid}`,
    pay: 'evisapayment/api/pay',
    submitPayment: (uuid, status) =>
      `evisapayment/api/payment-txes/${uuid}?status=${status}`,
    uploadDocument: (uuid, documentTypeId) =>
      `evisaonline/api/visa-applications/${uuid}/document?documentTypeId=${documentTypeId}`,
    updateDocument: (uuid, documentTypeId, docUuid) =>
      `evisaonline/api/visa-applications/${uuid}/document/${docUuid}?documentTypeId=${documentTypeId}`,
    messageAgent: uuid => `evisaonline/api/visa-applications/${uuid}/respond`,
    messageToApplicant: uuid =>
      `evisaonline/api/visa-applications/${uuid}/applicant-email`,
    getPaymentMethods: isLAO =>
      `evisapayment/api/payment-methods?requestChannel=${
        isLAO ? 'LOCAL' : 'WAF'
      }`,
    sendPaymentLink: uuid =>
      `evisaonline/api/visa-applications/${uuid}/payment-link-email`,
    markForLocalPayment: uuid =>
      `evisaonline/api/visa-applications/${uuid}/mark-for-local-payment`,
    getPaymentInfo: uuid => `evisapayment/api/quote/visa-application/${uuid}`,
    isZeroPayment: applicationId =>
      `evisapayment/api/quote/zero?applicationId=${applicationId}`,
    downloadApplication: applicationId =>
      `evisaonline/api/visa-applications/${applicationId}/download`,
  },
};



// WEBPACK FOOTER //
// ./src/conf/api.js